module.exports = __webpack_public_path__ + "img/winerackdog43.d4daf00f.jpg";